import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=25835856&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=25835856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25835856",
  null
  
)

export default component.exports